import * as heartBeatDetailsActions from '@Actions/heartBeatDetails';
import {
	GetHeartBeatStatusPayload,
	pollHeartBeatStatusStop,
} from '@Actions/heartBeatDetails';
import { getStatus } from '@Services/device';
import { HeartBeatStatus, HeartBeatStatusResponsePayload } from '@Types';
import { warning as snackbarWarn } from '@innovyze/stylovyze';
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { Task } from 'redux-saga';
import {
	call,
	cancel,
	cancelled,
	delay,
	fork,
	put,
	take,
} from 'redux-saga/effects';

function* getHeartBeatSaga(action: PayloadAction<GetHeartBeatStatusPayload>) {
	const { getHeartBeatStatusResolved, getHeartBeatStatusRejected } =
		heartBeatDetailsActions;

	if (action.payload?.stopAfterSec) {
		console.log(
			`polling will stop after ${action?.payload?.stopAfterSec} seconds`,
		);
	}

	try {
		while (true) {
			const response: AxiosResponse<HeartBeatStatusResponsePayload> =
				yield call(getStatus, 'HeartBeatShadow');

			if (response.data) {
				const heartBeatStatus: HeartBeatStatus = response.data;

				yield put(getHeartBeatStatusResolved(heartBeatStatus));
			} else {
				throw new Error('OperationStatus != SUCCESS');
			}
			// * Poll continues...
			yield delay(1000 * action.payload.pollDelaySec);
		}
	} catch (e) {
		console.error(e);
		yield put(getHeartBeatStatusRejected());
	} finally {
		// * This block gets called if the task (saga) gets cancelled
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		if (yield cancelled()) console.log('heartbeat poll was cancelled');
	}
}

function* stopPollHeartBeatSaga(
	action: PayloadAction<heartBeatDetailsActions.GetHeartBeatStatusPayload>,
) {
	try {
		const stopTout = action?.payload?.stopAfterSec;
		const stoppedMsg = `Health Status polling stopped after ${stopTout} seconds`;
		if (!stopTout) {
			return;
		}
		yield delay(1000 * stopTout);
		yield put(pollHeartBeatStatusStop());
		yield put(snackbarWarn(stoppedMsg));
		console.log(stoppedMsg);
	} catch (error) {
		console.log(error);
	} finally {
		// * This block gets called if the task (saga) gets cancelled
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		if (yield cancelled()) console.log('stop condition was cancelled');
	}
}

function* watchPollHeartBeat() {
	// * Custom implementation, similar to takeLatest but it's cancellable. Check getHeartBeatSaga
	while (true) {
		const action: unknown = yield take([
			heartBeatDetailsActions.getHeartBeatStatus,
		]);
		yield delay(1000 * 3); // ? possible lambda's cold start time
		const task: Task = yield fork(getHeartBeatSaga, action as never);
		const stopTask: Task = yield fork(
			stopPollHeartBeatSaga,
			action as never,
		);
		yield take([
			heartBeatDetailsActions.pollHeartBeatStatusStop,
			heartBeatDetailsActions.getHeartBeatStatusRejected,
		]);
		if (task.isRunning()) {
			yield cancel(task);
		}
		if (stopTask.isRunning()) yield cancel(stopTask);
	}
}

export default [
	watchPollHeartBeat(), //
];
